const style = document.createElement('style');
style.type = "text/css";
document.head.appendChild(style);

export default function (context, val) {
    if (!val) return;
    let date = new Date();
    let css = '';
    for (let k in val) {
        let i = val[k];
        switch (k){
            case 'MenuItemBackground':
                css+= '.app-header-wiki.is-active{color:' + i + '}';
                css += '.app-header-wiki.is-active a{color:' + i + '}';
                css += '.app-header-wiki.is-active .el-dropdown{color:' + i + '}';
                css += '.app-header-video.is-active{color:' + i + '}';
                css += '.app-header-video.is-active a{color:' + i + '}';
                css += '.app-header-video.is-active .el-dropdown{color:' + i + '}';
                css += '.mag .app-nav-menu .mag-link{background:' + i + '}';
                break;
            case 'MenuBackground':
                css += '.mag .app-nav{background:' + i + '}';
                css += '.mag .app-nav__top{background:' + i + '}';
                break;
            case 'MenuItemFontColor':
                css += '.mag .app-nav-menu .mag-link{color:' + i + '}';
                css += '.mag .app-nav-menu .mag-link:hover{color:' + i + '}';
                break;
            case 'MenuItemBlurBackground':
                css += '.mag .app-nav-menu .mag-link:hover{background:' + i + '}';
                break;
            case 'MenuItemSelectedBackground':
                css += '.mag .app-nav-menu .mag-link.router-link-active{background:' + i + '}';
                break;
            case 'MenuItemSelectedFontColor':
                css += '.mag .app-nav-menu .mag-link.router-link-active{color:' + i + '}';
                break;
            case 'FooterColor':
                css += '.mag footer{background:' + i + '}';
                break;
            case 'FooterContent':
                context.state.footer = i + ' © 2011-' + date.getFullYear() + ' MAG.travel Проект Master-Agent. Все права защищены. +7 (495) 6-020-020, info@mag.travel';
                break;
        }
    }
    style.innerHTML = css;
}